import { locationActions } from '../../../actions';
import createReducer from '../../../utils/createReducer';

export const locationReducer = createReducer(
  {},
  {
    [locationActions.update.type]: (state, { payload = {} }) => {
      return {
        ...payload,
      };
    },
  },
);
